export default "__VITE_ASSET__8n2_XlqT__"